export default __webpack_public_path__ + "static/media/CircularXXWeb-Bold.b47e1e54.woff2";